import { ActionButton } from '@emerald-works-nova/components'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { Box, Divider, Grid, Switch, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { BannerStatic } from '../../../components'
import { TenantEditSlice } from '../../../reducers'
import { useStyles } from './style'
import { useFeatureFormContext } from './feature-form-context'

const MindsetSettings = () => {
  const classes = useStyles()
  const { spacing } = useTheme()
  const dispatch = useDispatch()
  const { tenant } = useFeatureFormContext()
  const [isLoading, setIsLoading] = useState(false)

  const [value, setValue] = useState(tenant.features?.mindsetAi)

  const handleSwitch = () => {
    setValue(current => !current)
  }

  const [tenantUpdate] = useEvent([
    {
      eventName: 'tenantUpdate',
      onSuccess: (tenant) => {
        BannerStatic.show({ label: 'Ask M:Coach configuration updated' })
        setIsLoading(false)
        dispatch(TenantEditSlice.actions.updateTenantFeatures(tenant.features))
      },
      onError: () => {
        BannerStatic.show({
          label: 'There was an error saving the Ask M:Coach feature configuration',
          isError: true
        })
        setIsLoading(false)
      }
    }
  ])

  const handleSave = () => {
    tenantUpdate.trigger({
      pk: tenant.pk,
      features: {
        ...tenant.features,
        mindsetAi: value
      }
    })
    setIsLoading(true)
  }

  return (
    <Grid container className={classes.featContainer}>
      <Grid item xs={12}>
        <Box
          border={1}
          borderRadius='undefinedpx'
          borderColor='#E0E0E0'
          display='flex'
          style={{
            justifyContent: 'space-between',
            flexDirection: 'column',
            padding: spacing(1, 4)
          }}
        >
          <Box display='flex' flexDirection='row'>
            <Typography variant='body2' style={{ marginTop: spacing(3.5) }}>
                Ask M:Coach
            </Typography>
            <Box
              display='flex'
              style={{
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                flex: 1,
                padding: spacing(1)
              }}
            >
              <Box style={{ padding: spacing(2, 0.5) }}>
                <Switch
                  color='primary'
                  data-test='mindset-ai-feature-toggle'
                  checked={value}
                  onChange={handleSwitch}
                  disabled={isLoading}
                />
              </Box>
            </Box>
          </Box>

          <Divider style={{ marginBottom: spacing(1) }} />

          <Box display='flex' justifyContent='flex-end' mt={1} mb={1}>
            <ActionButton
              onClick={handleSave}
              disabled={isLoading}
              variant='primary'
              dataTest='mindset-ai-save-button'
              style={{ height: 'min-content' }}
            > Save
            </ActionButton>
          </Box>

        </Box>

      </Grid>

    </Grid>
  )
}

export default MindsetSettings
